import React from 'react'

interface ArrowLeftProps extends React.SVGProps<SVGSVGElement> {
  strokeWidth?: number
}

export const ArrowLeft = ({ className = '', strokeWidth = 2.5, ...props }: ArrowLeftProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      strokeWidth={strokeWidth}
      {...props}
    >
      <g clipPath="url(#clip0_7_414)">
        <path
          d="M11.9217 6.48047H3.92233L8.71022 2.32422C8.78679 2.25723 8.7403 2.13281 8.63913 2.13281H7.42917C7.37585 2.13281 7.32526 2.15195 7.28561 2.18613L2.11901 6.66914C2.07169 6.71016 2.03374 6.76087 2.00773 6.81784C1.98172 6.8748 1.96826 6.93669 1.96826 6.99932C1.96826 7.06194 1.98172 7.12383 2.00773 7.1808C2.03374 7.23776 2.07169 7.28847 2.11901 7.32949L7.31569 11.8398C7.3362 11.8576 7.36081 11.8672 7.38679 11.8672H8.63776C8.73893 11.8672 8.78542 11.7414 8.70886 11.6758L3.92233 7.51953H11.9217C11.9819 7.51953 12.0311 7.47031 12.0311 7.41016V6.58984C12.0311 6.52969 11.9819 6.48047 11.9217 6.48047Z"
          fill="#1999B9"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_414">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
